import React, { ReactNode } from 'react'
import cx from 'classnames'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'

import './title.scss'

export type TitleProps = {
  children?: ReactNode | string
  className?: string
  classes?: string
  headingLevel?: '1' | '1' | '2' | '3' | '4' | '5'
  isKeyNumber?: boolean
  bold?: boolean
}

function TitleComponent({
  children,
  className,
  classes,
  headingLevel,
  isKeyNumber = false,
  bold = false,
}: TitleProps) {
  const validHeadingLevels = ['1', '2', '3', '4', '5', '6']

  const safeHeading = headingLevel ? headingLevel.toLowerCase() : ''

  const Heading = (
    validHeadingLevels.includes(safeHeading) ? `h${safeHeading}` : 'span'
  ) as keyof JSX.IntrinsicElements

  return (
    <Heading
      className={cx(
        classes,
        {
          keyNumber: isKeyNumber,
          bold,
        },
        className,
      )}
    >
      {children}
    </Heading>
  )
}

export const Title = styleProvider(TitleComponent)
